import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import { NO, YES } from "pages/SurveyForm/constants/uiControls";
import StepContent from "../StepContent";

type Props = {
  formik: any;
  sectionId: number;
};

const Step9: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const clearHomeOwnershipField = (value: string) => {
    if (value === NO) {
      formik.setFieldValue("homeOwnership", []);
    }
  };
  const clearLandOwnershipField = (value: string) => {
    if (value === NO) {
      formik.setFieldValue("landOwnership", []);
    }
  };

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      name: "home",
      visible: true,
      questionData: questions[0],
      label: "¿Posee vivienda propia?",
      elementType: ElementType.Radio,
      onChangeCallback: clearHomeOwnershipField,
    },
    {
      key: 1,
      formik,
      checkboxStyle: {
        minWidth: "200px",
        margin: "0 1rem",
      },
      name: "homeOwnership",
      elementType: ElementType.Checkbox,
      questionData: questions[0]?.subQuestions[0],
      visible: formik.values.home?.value === YES,
      label: "¿A nombre de quién está la escritura de la vivienda?",
    },
    {
      key: 2,
      formik,
      name: "land",
      visible: true,
      label: "¿Posee lote propio?",
      questionData: questions[1],
      elementType: ElementType.Radio,
      onChangeCallback: clearLandOwnershipField,
    },
    {
      key: 3,
      formik,
      checkboxStyle: {
        minWidth: "200px",
        margin: "0 1rem",
      },
      name: "landOwnership",
      elementType: ElementType.Checkbox,
      questionData: questions[1]?.subQuestions[0],
      label: "¿A nombre de quién está la escritura del lote?",
      visible: formik.values.land?.value === YES,
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='center'>
        Cuéntenos sobre su patrimonio
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step9;
